import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';

import { i18n } from '@/i18n';

// console.log('colors', colors);

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#27846D',
        secondary: '#006099',
        text: '#333333',
        accent: '#A4A6A6', // '#5A769B',
        error: '#B64351',
        info: '#468BB5',
        success: '#7AC073',
        warning: '#E3B086',
        cancel: '#B36060',
        highlighted: colors.red.base,
        background: '#F1F1F1',
        lightgreen: '#B4FC1D',
        green: '#55D148',
        aqua: '#45A78F',
        blue: '#006099',
        darkblue: '#003A63',
        dgray: '#A4A6A6',
      },
    },
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
});
